/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFoundationIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-foundation"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.1 17.57L7.1 20.48Q7.1 21.02 6.71 21.41Q6.33 21.8 5.78 21.8Q5.22 21.8 4.84 21.41Q4.45 21.02 4.45 20.48L4.45 17.57L3.67 17.57Q3.13 17.57 2.75 17.19Q2.38 16.8 2.38 16.25Q2.38 15.7 2.76 15.32Q3.15 14.95 3.7 14.95L4.45 14.95L4.45 11.4L2.85 12.65Q2.42 13 1.88 12.93Q1.32 12.85 0.97 12.4Q0.65 11.97 0.72 11.44Q0.8 10.9 1.23 10.55L10.38 3.45Q10.72 3.17 11.15 3.04Q11.57 2.9 12 2.9Q12.43 2.9 12.85 3.04Q13.28 3.17 13.63 3.45L22.77 10.55Q23.2 10.9 23.26 11.44Q23.32 11.97 23 12.4Q22.65 12.85 22.1 12.93Q21.55 13 21.13 12.65L19.52 11.4L19.52 14.95L20.3 14.95Q20.85 14.95 21.23 15.32Q21.6 15.7 21.6 16.25Q21.6 16.8 21.23 17.19Q20.85 17.57 20.3 17.57L19.52 17.57L19.52 20.5Q19.52 21.05 19.15 21.43Q18.77 21.8 18.23 21.8Q17.68 21.8 17.29 21.41Q16.9 21.02 16.9 20.48L16.9 17.57L13.32 17.57L13.32 20.48Q13.32 21.02 12.94 21.41Q12.55 21.8 12 21.8Q11.45 21.8 11.06 21.41Q10.68 21.02 10.68 20.48L10.68 17.57ZM7.1 14.95L10.68 14.95L10.68 6.58L7.1 9.35ZM13.32 14.95L16.9 14.95L16.9 9.35L13.32 6.58Z" fill={color} />
    </svg>
  );
}
